import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getAllUsers = createAsyncThunk(
    "user/getAllUsers",
    async (userData, { rejectWithValue }) => {
        try {
            const response = await axios.post("/user/getAllUsers",
                userData, {
                headers: {
                    "Content-Type": "application/json",
                    "token": userData.token
                }
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getUserInfoDetailsByUserId = createAsyncThunk(
    "user/getUserInfoDetailsByUserId",
    async (userData, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                "/user/getUserInfoDetailsByUserId",
                userData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "token": userData.token,
                    },
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const checkUserExist = createAsyncThunk(
    "user/checkUser",
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await axios.post("/user/checkUser",
                credentials, {
                headers: {
                    "Content-Type": "application/json",
                    token: credentials.token
                },
            }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

const initialState = {
    users: [],
    userInfoDetails: [],
    loading: false,
    searchMessage: null,
    userExistsuccessMessage: null,
    userExistErrorMessage: null,
    userExistLoading: false,
    checkExistUserData: null,
};

const usersSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        resetUsersSearchMessage: (state) => {
            state.searchMessage = null;
        },
     resetCheckUserExist: (state) => {
        state.checkExistUserData = null;
        state.userExistsuccessMessage = null;
        state.userExistErrorMessage = null;
        state.userExistLoading = false;
    },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllUsers.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllUsers.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.searchMessage = action.payload.result.message;
                }
                state.users = action.payload.result.list;
            })
            .addCase(getAllUsers.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(getUserInfoDetailsByUserId.pending, (state) => {
                state.loading = true;
                state.searchMessage = null;
            })
            .addCase(getUserInfoDetailsByUserId.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.searchMessage = action.payload.result.message;
                }
                state.userInfoDetails = action.payload.result.list;
            })
            .addCase(getUserInfoDetailsByUserId.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(checkUserExist.pending, (state) => {
    state.userExistLoading = true;
    state.userExistErrorMessage = null;
    state.userExistsuccessMessage = null;
})

.addCase(checkUserExist.fulfilled, (state, action) => {
    state.userExistLoading = false;

    if (action.payload.success === false) {
        state.userExistErrorMessage = action.payload.result.message;
        state.checkExistUserData = null;
    } else {
        state.userExistsuccessMessage = action.payload.result.message;
        state.checkExistUserData = action.payload.result.list;
    }
})

.addCase(checkUserExist.rejected, (state, action) => {
    state.userExistLoading = false;
    state.userExistErrorMessage = action.payload;
    state.checkExistUserData = null;
});
    },
});

export const { resetUsersSearchMessage,  resetCheckUserExist, } = usersSlice.actions;

export default usersSlice.reducer;